import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import { AlertsState, AlertMessage } from "./alertsTypes";

const initialState: AlertsState = {
  alerts: [],
  maxAlerts: 5,
};

const alertsSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    pushAlert: {
      reducer: (state, action: PayloadAction<AlertMessage>) => {
        state.alerts.unshift(action.payload);

        // Remove oldest alert if we exceed maxAlerts
        if (state.alerts.length > state.maxAlerts) {
          state.alerts.pop();
        }
      },
      prepare: (alert: Omit<AlertMessage, "id">) => {
        return {
          payload: {
            ...alert,
            id: uuidv4(),
            autoClose: alert.autoClose ?? true,
            autoCloseDelay: alert.autoCloseDelay ?? 5000,
          },
        };
      },
    },
    closeAlert: (state, action: PayloadAction<string>) => {
      state.alerts = state.alerts.filter(
        (alert) => alert.id !== action.payload
      );
    },
    clearAlerts: (state) => {
      state.alerts = [];
    },
    setMaxAlerts: (state, action: PayloadAction<number>) => {
      state.maxAlerts = action.payload;
    },
  },
});

export const { pushAlert, closeAlert, clearAlerts, setMaxAlerts } =
  alertsSlice.actions;

export default alertsSlice.reducer;
